<template>
  <div class="cityAreaList">
    <div class="list-contaienr">
      <div class="card">
        <div class="table-data">
          <table>
            <tr>
              <td align="">排名</td>
              <td>区域</td>
              <td>退货量</td>
              <td>退货占比</td>
            </tr>
            <tr v-for="(item, index) in countyList">
              <td>{{ index + 1 }}</td>
              <td style="color: #229f60" @click="toRefundList(item, index)">
                {{ item.F_NAME }}
              </td>
              <td>{{ item.count }}</td>
              <td>{{ item.proportion }}</td>
            </tr>
          </table>
        </div>

         <div
          class="btn"
          style="margin-top: 17px;"
          @click="$router.back()"
        >
          <span>收起</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from "@/service/modules/refund";

export default {
  data() {
    return {
      queryType: "1",
      countyList: [],
    };
  },
  components: {},
  mounted() {},
  created() {
    this.currentUser();
  },
  methods: {
    currentUser() {
      api.currentUser().then((res) => {
        if (res.ret === 0) {
          this.regionalReturnRanking(res.data.regionCode);
        } else {
          this.params.reginCode = "";
        }
      });
    },
    //请求全部热门退货地区处理数据
    regionalReturnRanking(regionCode) {
      let params = {
        value: "",
        dataType: "",
        startTime: "",
        endTime: "",
        liftingSequence: "",
        sort: "",
        orgId: "",
        reginCode: regionCode,
      };
      api.regionalReturnRanking(params, this.queryType).then((res) => {
        if (res.ret === 0) {
          this.countyList = res.data.regionalReturnRankingMap;
        } else {
          this.countyList = [];
        }
      });
    },
    // 跳转区县退货列表
    toRefundList(item, index) {
      this.$router.push({
        path: "/refund/cityAreaRefundList",
        query: {
          cityIndex: index,
          queryType: this.queryType,
          areaId: item.cityId,
          areaName: item.F_NAME
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cityAreaList {
  background-color: #f9fafc;
  /deep/.van-tab {
    padding: 0 16px;
  }
  .list-contaienr {
    padding: 12px;
  }
  // /deep/.van-tabs__line {
  //   width: 20px !important;
  //   transform: translateX(38.5px) translateX(-50%);
  //   background-color: #36B374;
  // }
  .card {
    margin-top: 12px;
    padding: 0 12px 16px 12px;
    background: #ffffff;
    border-radius: 3px;
    .table-data {
      table {
        width: 100%;
        border-collapse: collapse;
      }
      tr {
        font-size: 14px;
        line-height: 46px;
        border-bottom: 1px #f5f6f9 solid;
        color: #1e2226;
        td:nth-of-type(1) {
          text-align: center;
        }
        td:nth-of-type(2) {
          width: 135px;
          max-width: 135px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        td:nth-of-type(3) {
          text-align: center;
        }
        td:nth-of-type(4) {
          text-align: right;
        }
      }
      tr:first-child {
        font-size: 12px;
        color: #71747a;
        line-height: 36px;
        td {
          color: #71747a !important;
          &:nth-of-type(1) {
            text-align: center;
          }
        }
      }
    }

    .btn {
      padding: 0 16px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;
      span {
        position: relative;
        padding-right: 11px;
      }
      span::after {

        content: "";
        position: absolute;
           right: -13px;
        top: -3px;
        transform: rotate(-90deg);
        width: 20px;
        height: 20px;
        background: url(../../../../../assets/image/ic_jt_ck@2x.png) no-repeat;
        background-size: 12px 12px;
      }
    }
  }
}
</style>
